module.exports = __webpack_public_path__ + "static/img/bigMap.67e734c3.png";